import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";

import {
  fetchCarecellsSuccess,
  fetchCarecellsFailure,
  saveCarecellSuccess,
  saveCarecellFailure,
  deleteCarecellSuccess,
  deleteCarecellFailure,
  updateCarecellSuccess,
  updateCarecellFailure,
} from "./action";

import {
  fetchCarecells,
  saveCarecell,
  deleteCarecell,
  updateCarecell,
  fetchCarecellById,
} from "./carecell.js";

// 🔹 Fetch Carecells
function* fetchCarecellsSaga(action) {
  try {
    const { _id } = action.payload;
    const data = yield call(fetchCarecells, _id);
    yield put(fetchCarecellsSuccess(data?.data || []));
    if (typeof action.callback === "function")
      action.callback({ type: 1, data: data?.data });
  } catch (error) {
    yield put(fetchCarecellsFailure(error.message));
    if (typeof action.callback === "function")
      action.callback({ type: 0, error: error.message });
  }
}

// 🔹 Save Carecell
function* saveCarecellSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveCarecell, apiPayloadRequest);
    yield put(saveCarecellSuccess(data?.data || data));
      if (typeof action.callback === "function")
          action.callback({
            type: data?.type,
            data: data?.data,
            message: data?.message,
           carecellObjId: data?.carecellObjId, // ✅ include this
          });
  } catch (error) {
    yield put(saveCarecellFailure(error.message));
    if (typeof action.callback === "function")
      action.callback({ type: 0, error: error.message });
  }
}

// 🔹 Update Carecell
// 🔹 Update Carecell (Corrected for new flow)
function* updateCarecellSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload; // ✅ correct structure
    const data = yield call(updateCarecell, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(updateCarecellSuccess(data?.data || apiPayloadRequest));
      if (typeof action.callback === "function")
        action.callback({ type: 1, data: data?.data });
    } else {
      yield put(updateCarecellFailure(data?.error || "Update failed"));
      if (typeof action.callback === "function")
        action.callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(updateCarecellFailure(error.message));
    if (typeof action.callback === "function")
      action.callback({ type: 0, error: error.message });
  }
}


// 🔹 Delete Carecell
function* deleteCarecellSaga(action) {
  try {
    const { _id, carecellObjId } = action.payload; // ✅ accept both IDs
    const data = yield call(deleteCarecell, { _id, carecellObjId }); // ✅ pass both to API

    if (data?.type === 1) {
      // ✅ Update reducer cleanly
      yield put(deleteCarecellSuccess({ _id, carecellObjId }));

      // ✅ Trigger callback
      if (typeof action.callback === "function") {
        action.callback({ type: 1, data: data?.data });
      }
    } else {
      const errorMsg = data?.error || "Delete failed";
      yield put(deleteCarecellFailure(errorMsg));

      if (typeof action.callback === "function") {
        action.callback({ type: 0, error: errorMsg });
      }
    }
  } catch (error) {
    yield put(deleteCarecellFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}


export default function* carecellsWatcherSaga() {
  yield takeLatest(actionTypes.FETCH_CARECELLS_REQUEST, fetchCarecellsSaga);
  yield takeLatest(actionTypes.SAVE_CARECELL_REQUEST, saveCarecellSaga);
  yield takeLatest(actionTypes.UPDATE_CARECELL_REQUEST, updateCarecellSaga);
  yield takeLatest(actionTypes.DELETE_CARECELL_REQUEST, deleteCarecellSaga);
}
